import { Controller } from "@hotwired/stimulus";

// Submit the form on any descendant input's change event. Handy for GET
// filter strips with a Forms::SelectComponent — drop the controller on
// the <form> and add data-action="change->form-auto-submit#submit" on
// the field's data_attributes. No backend round-trip jitter, no inline
// onchange="this.form.requestSubmit()" that bypasses the design system.
export default class extends Controller {
  submit() {
    this.element.requestSubmit();
  }
}
